class ScamWarningToast {
    constructor() {
        this.toast = document.querySelector('.toast-scam-warning');
        this.closeButton = this.toast?.querySelector('.btnCloseScamWarning');

        if (!this.toast || !this.closeButton) return;

        this.storageKey = 'bma-scam-warning-dismissed-v1';

        if (this.isDismissed()) return;

        this.bindEvents();
        this.open();
    }

    isDismissed() {
        try {
            return localStorage.getItem(this.storageKey) === '1';
        } catch (e) {
            return false;
        }
    }

    open() {
        window.setTimeout(() => {
            this.toast.classList.add('active');
            this.toast.removeAttribute('aria-hidden');
        }, 600);
    }

    close() {
        this.toast.classList.remove('active');
        this.toast.setAttribute('aria-hidden', 'true');

        try {
            localStorage.setItem(this.storageKey, '1');
        } catch (e) {
            // localStorage indisponível (ex.: navegação privada) - o aviso pode reaparecer na próxima visita
        }
    }

    bindEvents() {
        this.closeButton.addEventListener('click', () => this.close());

        document.addEventListener('keydown', event => {
            if (event.key === 'Escape' && this.toast.classList.contains('active')) {
                this.close();
            }
        });
    }
}

new ScamWarningToast();
